import cubejs from '@cubejs-client/core';
import {getToken} from "../Auth";
import {cubeUrl} from '../Conf';
const cube = cubejs(
    async () => await getToken(),
    { apiUrl: `${cubeUrl}/cubejs-api/v1` }
);
export default cube;